<template>

<div class="awards" v-if="awards.plays || awards.wins">

	<core-award award="Most played with" type="user" :id="awards.plays.id" :winner="awards.plays.name" :ties="awards.plays.ties" :value="awards.plays.value" v-if="awards.plays && isUser" />

	<core-award award="Most plays" type="user" :id="awards.plays.id" :winner="awards.plays.name" :ties="awards.plays.ties" :value="awards.plays.value" v-if="awards.plays && !isUser" />

	<core-award award="Highest win %" :caveat="'Min. ' + awards.wins.min + ' result' + ((awards.wins.min !== 1) ? 's' : '')" type="user" :id="awards.wins.id" :winner="awards.wins.name" :ties="awards.wins.ties" :value="awards.wins.value" :percent="true" v-if="awards.wins" />

</div>

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		awards: function() {

			var contextual = (this.item.context) ? this.item.context : this.item

            var awards = {
                plays: false,
                wins: false
            }

			var plays
			var players = this.$_.sortBy(this.item.players, 'name')

			if (this.isUser) {

				if (this.item.players.length > 1) {

					plays = this.$_.last(this.$_.sortBy(this.$_.filter(players, function(player) { return player.id !== this.$store.getters['context/id'] }.bind(this)), 'plays'))

					awards.plays = {
						id: plays.id,
						name: (plays.name) ? plays.name : 'Anonymous',
						value: plays.plays,
						ties: this.$_.filter(players, function(player) {

							return player.plays === plays.plays && player.id !== plays.id && player.id !== this.$store.getters['context/id']

						}.bind(this)).length
					}

				}
					
			} else {

				if (contextual.users.totalPlays) {

					var played = []

					this.$_.each(contextual.users.played, function(plays, id) {

						played.push({
							id: id,
							plays: plays,
							name: this.$store.getters['data/users/associated'][id].fullname || this.$store.getters['data/users/associated'][id].name
						})

					}.bind(this))

					plays = this.$_.last(this.$_.sortBy(played, 'plays'))

					awards.plays = {
						id: plays.id,
						name: plays.name,
						value: plays.plays,
						ties: this.$_.filter(played, function(player) {

							return player.plays === plays.plays && player.id !== plays.id

						}).length
					}

				}

			}

			if (this.item.record.results > 0) {

				var threshold = 5

				if (this.item.record.results <= 2) threshold = 1
				else if (this.item.record.results <= 5) threshold = 2
				else if (this.item.record.results <= 10) threshold = 3
				else if (this.item.record.results <= 15) threshold = 4

				var highestResults = this.$_.reduce(players, function(high, player) {

					if (player.wins) {

						return (high < player.results) ? player.results : high

					} else {

						return high

					}

				}, 0)

				threshold = (highestResults < threshold) ? highestResults : threshold

				if (threshold > 0) {

					var wins = this.$_.last(this.$_.sortBy(this.$_.filter(players, function(player) { return player.results >= threshold && player.wins > 0 }), function(player) {

						return (100 / player.results) * player.wins

					}))

					if (wins) {

						var highestWinPercent = (100 / wins.results) * wins.wins

						var name = (wins.name) ? wins.name : 'Anonymous'

						if (!this.isUser) {

							name = this.$store.getters['data/users/associated'][wins.id].fullname || this.$store.getters['data/users/associated'][wins.id].name

						}

						awards.wins = {
							min: threshold,
							id: wins.id,
							name: name,
							value: highestWinPercent,
							ties: this.$_.filter(players, function(player) {

								return (100 / player.results) * player.wins === highestWinPercent && player.id !== wins.id

							}).length
						}
					
					}

				}

			} 

            return awards

		}

	}

}

</script>

<style scoped>

.awards {
    padding-top: 10px;
}

</style>
